<!-- The add/edit template modal -->
<div class="modal-content">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="modal-header-left">
        <h4 class="modal-title">Select Template</h4>
      </div>
      <div class="modal-header-right">
        <button type="button" class="close" (click)="close()">
          <i class="icon-close"></i>
        </button>
      </div>
    </div>
    <!-- Modal body -->
    <form
      class="modal-body"
      [formGroup]="templateForm"
      (ngSubmit)="onSubmit()"
    >
      <div class="modal-body-inner">
        <div class="form-custom-div">
          <div class="row">
            <div class="col-lg-12 col-md-12">
                <app-ngx-datatable
                [singleSelect]="true"
                [hideGrouping]="true"
                [columns]="columns"
                [dataset]="dataset"
                [trigger]="trigger"
                [externalSorting]="false"
                [externalPaging]="true"
                [showEnteriesDropdown]="true"
                [isBulkDeleteEnable]="false"
                [isBulkUpdateEnable]="false"
                [isLightHeader]="true"
                [showExport]="false"
                (payload)="payloadListener($event)"
                [actionColumnWidth]="170"
              ></app-ngx-datatable>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer-bottom mt-2">
        <app-modal-action-btns
          [form]="templateForm"
          (onReject)="close()"
        ></app-modal-action-btns>
      </div>
    </form>
  </div>

<ng-template #actions let-row="row">
    <div class="action-box d-flex w-100"> 
      <a
        class="btn btn-delete-action btn-action-new-delete"
        (click)="viewRow(row)"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          aria-hidden="true"
          role="img"
          width="20"
          height="20"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 24 24"
        >
          <g fill="none">
            <path
              d="M21.257 10.962c.474.62.474 1.457 0 2.076C19.764 14.987 16.182 19 12 19c-4.182 0-7.764-4.013-9.257-5.962a1.692 1.692 0 0 1 0-2.076C4.236 9.013 7.818 5 12 5c4.182 0 7.764 4.013 9.257 5.962z"
              stroke="var(--opengov-primary-blurple)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle
              cx="12"
              cy="12"
              r="3"
              stroke="var(--opengov-primary-blurple)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </svg>
      </a>
    </div>
  </ng-template>